import { Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { EmptyIconDirective } from '../datatable/components/empty/empty-icon.directive';
import { EmptyComponent } from '../datatable/components/empty/empty.component';
import { EmptySubHeaderComponent } from '../datatable/components/empty/empty-sub-header.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'td-wb-application-error',
  templateUrl: 'application-error.component.html',
  styleUrls: ['./application-error.component.scss'],
  imports: [
    IconComponent,
    EmptyComponent,
    EmptySubHeaderComponent,
    EmptyIconDirective,
    TranslateDirective
  ]
})
export class ApplicationErrorComponent {
  readonly header = input<string>('tdWb.application.error.HEADER');
  readonly title = input<string>('tdWb.application.error.DESCRIPTION_I');
  readonly subTitle = input<string>('tdWb.application.error.DESCRIPTION_II');
}
